import React from "react";
import ACME_Logo from "../../../../../assets/images/market/ACME_Logo.png";
import LOCAL_STORAGE from "../../../../../_redux/localStorage";

import s from "./WeaveDetails.module.scss";

export default function WeaveDetails({ product, weave = {} }) {
	const weaveDID = product ? product.did?.split(":").splice(0, 3).join(":") : "";

	let stateData = LOCAL_STORAGE.loadState() || {};

	const weaveLogo = stateData.useMocks
		? weave?.logo
		: weave?.logo
		? "data:image/svg+xml;base64," + weave.logo
		: ACME_Logo;

	return (
		<div className={s.root}>
			<div className={s.sectionSubtitle}>Weave Details</div>
			<div className={s.media}>
				<img src={weaveLogo} className={s.logo} alt="logo" />

				<div className={s.mediaInfo}>
					<p className={s.title}>{weave?.name}</p>
					<p className={s.key}>DID: {weaveDID}</p>
					<p className={s.label}>{weave?.description}</p>
				</div>
			</div>
		</div>
	);
}
